module.exports = __webpack_public_path__ + "static/media/Priyanka.85baa1d8.png";